var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { "data-ver": _vm.$root.content.version } }, [
    _c("div", { staticClass: "wrapper__header" }, [
      _c(
        "div",
        { staticClass: "wrapper__headerImage" },
        [
          _c("div", {
            staticClass: "headerImage__shadow",
            style: {
              backgroundImage:
                "url(" +
                _vm.allImages[_vm.$root.content.header.image.src]
                  .ImgthumbBlurLarge +
                ")"
            }
          }),
          _vm._v(" "),
          _c("responsive-image", {
            style: {
              borderRadius: "8px",
              overflow: "hidden"
            },
            attrs: {
              image: _vm.allImages[_vm.$root.content.header.image.src].Img600,
              imageFiles: _vm.allImages[_vm.$root.content.header.image.src],
              alt: _vm.$root.content.header.image.alt
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wrapper__parts" },
      _vm._l(_vm.$root.content.parts, function(part, i) {
        return _c(
          "a",
          {
            key: "part-" + i,
            class: {
              wrapper__link: true,
              "wrapper__link--hover": _vm.hoveredLink === part.type
            },
            style: _vm.style__link,
            attrs: { href: part.link },
            on: {
              mouseover: function($event) {
                _vm.mouseoverLink(part.type)
              },
              mouseout: _vm.mouseoutLink
            }
          },
          [
            _c("div", { staticClass: "glow" }),
            _vm._v(" "),
            _c("p", { staticClass: "link__text link__text--title" }, [
              _c("b", [_vm._v(_vm._s(part.title))])
            ]),
            _vm._v(" "),
            part.subtitle
              ? _c("p", { staticClass: "link__text link__text--subtitle" }, [
                  _c("i", [_vm._v(_vm._s(part.subtitle))])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "icon__wrapper" }, [
              _c(part.icon, { tag: "div", attrs: { fill: "#efefef" } })
            ])
          ]
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f7b704e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f7b704e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/link-block.vue
// module id = null
// module chunks = 